import ReactMarkdown from 'react-markdown';
import styles from './SeoReportViewer.module.css';

const TRUNCATE_RE = /^#{1,6}\s*(next actions?|action items?|recommendations?|what (to do|you should do) next)/i;

const truncateAtNextActions = (text = '') => {
  const lines = text.split('\n');
  const cutIndex = lines.findIndex((line) => TRUNCATE_RE.test(line.trim()));
  return cutIndex === -1 ? text : lines.slice(0, cutIndex).join('\n').trimEnd();
};

const SeoReportViewer = ({ data = {} }) => {
  const { report_body, summary, url, domain, generated_at } = data;
  const visibleBody = report_body ? truncateAtNextActions(report_body) : null;

  return (
    <div className={styles.container}>
      {(domain || url) && (
        <div className={styles.metaBar}>
          {domain && <span className={styles.metaDomain}>{domain}</span>}
          {generated_at && (
            <span className={styles.metaDate}>
              {new Date(generated_at).toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
              })}
            </span>
          )}
        </div>
      )}

      {summary && (
        <div className={styles.summaryCard}>
          <p className={styles.summaryEyebrow}>Summary</p>
          <p className={styles.summaryText}>{summary}</p>
        </div>
      )}

      {visibleBody ? (
        <div className={styles.markdownBody}>
          <ReactMarkdown>{visibleBody}</ReactMarkdown>
        </div>
      ) : (
        <div className={styles.emptyState}>
          <p>No report content available.</p>
        </div>
      )}
    </div>
  );
};

export default SeoReportViewer;
